module.exports = __webpack_public_path__ + "img/light_1.e70ba033.png";